import { PersonSex, ResidencyStatus } from "@/constants/PersonConstants";
import {
    BankAccountData,
    CitizenPassportDataDTO,
    EADDataDTO, ForeignPassportDataDTO,
    GreenCardDataDTO,
    SSNCardDataDTO, StateIDDataDTO
} from "@/dto/request/rer/CompleteREREmployeePayload";
import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CompleteRIDCContractorPayload {

    id: number | null = null;
    residencyStatus: ResidencyStatus | null = null;
    personId: number | null = null;
    contractorId: number | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    sex: PersonSex | null = null;
    countryOfBirth: string | null = null;
    dateOfBirth: string | null = null;
    nationality?: string | null = null;
    contractStart: Date | null = null;
    ead?: EADDataDTO | null = null;
    greenCard?: GreenCardDataDTO | null = null;
    passport?: CitizenPassportDataDTO | null = null;
    ssn: SSNCardDataDTO | null  = null;
    stateID: StateIDDataDTO | null = null;
    bankAccount: BankAccountData | null = null;
    addressConfirmationImage: FileMetaDTO | null = null;
    isW9Required = true;
    foreignPassport: ForeignPassportDataDTO | null = null;

    constructor(init?: Partial<CompleteRIDCContractorPayload>) {
        Object.assign(this, init);
    }

}
